
import Flickity from 'flickity'


function init(el, controls, options = {}) {
	var carousel = new Flickity(el, {
	  cellAlign: 'left',
	  contain: true,
	  pageDots: false,
	  wrapAround: true,
	  groupCells: true,
	  arrowShape: { 
	    x0: 20,
	    x1: 70, y1: 50,
	    x2: 75, y2: 45,
	    x3: 30
	  },
	  ...options
	});
}

export function carousel(selector, controlsSelector, options) {
	const els = document.querySelectorAll(selector)
	els.forEach(el => {
		const controls = el.querySelector(controlsSelector)
		init(el, controls, options)
	})
}